if (!customElements.get('multiple-variant-add')) {
  customElements.define(
    'multiple-variant-add',
    class MultipleVariantAdd extends HTMLElement {
      constructor() {
        super();
        this.productForm = this.querySelector('form');
        this.submitButton = this.querySelector('button[type="submit"]');
        this.quantityInputs = this.querySelectorAll('input[name="quantity[]"]');
        this.quantitySelects = this.querySelectorAll('select');
        this.modal = this.closest('slide-modal');
        this.productForm.addEventListener('submit', this.handleSubmit.bind(this));
      }

      serialize(data) {
        let obj = {};
        for (let [key, value] of data) {
          if (obj[key] !== undefined) {
            if (!Array.isArray(obj[key])) {
              obj[key] = [obj[key]];
            }
            obj[key].push(value);
          } else {
            obj[key] = value;
          }
        }
        return obj;
      }

      handleSubmit(e) {
        if (e) {
          e.preventDefault();
        }
        // Get all field data from the form
        let data = new FormData(this.productForm),
          payload = [],
          i = 0,
          obj = {},
          qty = 0,
          id = 0;

        // Serialize the data into a usable object
        obj = this.serialize(data);

        if (obj['quantity[]'] && obj['quantity[]'].length > 0) {
          for (i = 0; i < obj['quantity[]'].length; i++) {
            qty = parseInt(obj['quantity[]'][i]);
            id = parseInt(obj['id[]'][i]);
            if (!qty) {
              continue;
            }
            payload.push({
              id: id,
              quantity: qty,
            });
          }
        }

        if (payload.length === 0) {
          console.log('no items to add');
          return false;
        }

        this.submitButton.classList.add('loading');
        this.submitButton.setAttribute('disabled', 'disabled');
        this.submitButton.offsetWidth; // trigger reflow

        fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            items: payload,
          }),
        })
          .then((response) => {
            return response.text();
          })
          .then((state) => {
            const parsedState = JSON.parse(state);
            console.log(parsedState);
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'multiple-variant-add',
              cartData: parsedState,
              openDrawer: true,
            });

            //reset all quantity inputs and selects to 0
            this.quantityInputs.forEach((input) => {
              input.value = 0;
            });
            this.quantitySelects.forEach((select) => {
              select.value = 0;
            });

            const cartDrawer = document.querySelector('cart-drawer');
            if (this.modal) {
              this.modal.close();
            }

            return false;
          })
          .catch((error) => {
            console.error('Error:', error);
          });

        this.submitButton.classList.remove('loading');
        this.submitButton.removeAttribute('disabled');

        return false;
      }
    }
  );
}
